// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgentSearchController from "./agent_search_controller"
application.register("agent-search", AgentSearchController)

import ColumnOrderController from "./column_order_controller"
application.register("column-order", ColumnOrderController)

import Form__ColorPickerController from "./form/color_picker_controller"
application.register("form--color-picker", Form__ColorPickerController)

import Form__DateController from "./form/date_controller"
application.register("form--date", Form__DateController)

import Form__HeightController from "./form/height_controller"
application.register("form--height", Form__HeightController)

import Form__NestedFieldsController from "./form/nested_fields_controller"
application.register("form--nested-fields", Form__NestedFieldsController)

import Form__ParserController from "./form/parser_controller"
application.register("form--parser", Form__ParserController)

import Form__PhoneController from "./form/phone_controller"
application.register("form--phone", Form__PhoneController)

import Form__WeightController from "./form/weight_controller"
application.register("form--weight", Form__WeightController)

import Help__SearchController from "./help/search_controller"
application.register("help--search", Help__SearchController)

import Landing__RosterViewController from "./landing/roster_view_controller"
application.register("landing--roster-view", Landing__RosterViewController)

import Lists__AddToListController from "./lists/add_to_list_controller"
application.register("lists--add-to-list", Lists__AddToListController)

import Lists__PlayerSearchController from "./lists/player_search_controller"
application.register("lists--player-search", Lists__PlayerSearchController)

import Mfa__ResendCountdownController from "./mfa/resend_countdown_controller"
application.register("mfa--resend-countdown", Mfa__ResendCountdownController)

import PlayerSearchForm__ChipController from "./player_search_form/chip_controller"
application.register("player-search-form--chip", PlayerSearchForm__ChipController)

import PlayerSearchForm__FormController from "./player_search_form/form_controller"
application.register("player-search-form--form", PlayerSearchForm__FormController)

import PlayerSearchForm__ToggleController from "./player_search_form/toggle_controller"
application.register("player-search-form--toggle", PlayerSearchForm__ToggleController)

import PricingIntervalController from "./pricing_interval_controller"
application.register("pricing-interval", PricingIntervalController)

import Rosters__BoardController from "./rosters/board_controller"
application.register("rosters--board", Rosters__BoardController)

import Rosters__ToggleFieldController from "./rosters/toggle_field_controller"
application.register("rosters--toggle-field", Rosters__ToggleFieldController)

import ScoutingReportFormController from "./scouting_report_form_controller"
application.register("scouting-report-form", ScoutingReportFormController)

import ScoutingTemplateBuilderController from "./scouting_template_builder_controller"
application.register("scouting-template-builder", ScoutingTemplateBuilderController)

import SettingsArchivedController from "./settings_archived_controller"
application.register("settings-archived", SettingsArchivedController)

import SettingsOrderController from "./settings_order_controller"
application.register("settings-order", SettingsOrderController)

import SettingsTabsController from "./settings_tabs_controller"
application.register("settings-tabs", SettingsTabsController)

import Shared__AutoSubmitController from "./shared/auto_submit_controller"
application.register("shared--auto-submit", Shared__AutoSubmitController)

import Shared__CommentsModalController from "./shared/comments_modal_controller"
application.register("shared--comments-modal", Shared__CommentsModalController)

import Shared__DialogOpenerController from "./shared/dialog_opener_controller"
application.register("shared--dialog-opener", Shared__DialogOpenerController)

import Shared__DropdownController from "./shared/dropdown_controller"
application.register("shared--dropdown", Shared__DropdownController)

import Shared__FeedPanelController from "./shared/feed_panel_controller"
application.register("shared--feed-panel", Shared__FeedPanelController)

import Shared__FlashController from "./shared/flash_controller"
application.register("shared--flash", Shared__FlashController)

import Shared__MentionsController from "./shared/mentions_controller"
application.register("shared--mentions", Shared__MentionsController)

import Shared__ModalController from "./shared/modal_controller"
application.register("shared--modal", Shared__ModalController)

import Shared__MultiSelectController from "./shared/multi_select_controller"
application.register("shared--multi-select", Shared__MultiSelectController)

import Shared__NavController from "./shared/nav_controller"
application.register("shared--nav", Shared__NavController)

import Shared__NotificationToastController from "./shared/notification_toast_controller"
application.register("shared--notification-toast", Shared__NotificationToastController)

import Shared__ResetFormController from "./shared/reset_form_controller"
application.register("shared--reset-form", Shared__ResetFormController)

import Shared__ResourcesMenuController from "./shared/resources_menu_controller"
application.register("shared--resources-menu", Shared__ResourcesMenuController)

import Shared__StickyStateController from "./shared/sticky_state_controller"
application.register("shared--sticky-state", Shared__StickyStateController)

import Shares__FormController from "./shares/form_controller"
application.register("shares--form", Shares__FormController)

import TeamManagement__EditMemberController from "./team_management/edit_member_controller"
application.register("team-management--edit-member", TeamManagement__EditMemberController)

import TourController from "./tour_controller"
application.register("tour", TourController)
